import { selector } from 'recoil';
import currentUserState from './current-user-state.js';
import currentUserTokenState from './current-user-token-state.js';
const currentUserTypeState = selector({
    key: 'currentUserType',
    get: ({ get }) => {
        const currentUser = get(currentUserState.response);
        const currentUserToken = get(currentUserTokenState);
        if (currentUserToken && currentUser?.User) {
            const userType = currentUser.User.Type;
            return {
                ID: currentUser.User.ID,
                isAnonymous: (userType & 4) !== 0,
                isLoggedIn: (currentUser.User.Type & 1) !== 0 || (currentUser.User.Type & 2) !== 0,
                isCustomer: (userType & 2) !== 0,
                isEmployee: (userType & 1) !== 0,
            };
        }
        return {
            ID: 0,
            isAnonymous: true,
            isLoggedIn: false,
            isCustomer: false,
            isEmployee: false,
        };
    },
});
export default currentUserTypeState;
//# sourceMappingURL=current-user-type-state.js.map